import { render, staticRenderFns } from "./LoginDialog.vue?vue&type=template&id=37c1f71a&scoped=true"
import script from "./LoginDialog.vue?vue&type=script&lang=js"
export * from "./LoginDialog.vue?vue&type=script&lang=js"
import style0 from "./LoginDialog.vue?vue&type=style&index=0&id=37c1f71a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c1f71a",
  null
  
)

export default component.exports